import { Injectable, inject } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

/**
 * Record the state of the routing
 */
@Injectable({
  providedIn: 'root'
})
export class RoutingStateService {
  private router = inject(Router);


  history: string[] = [];

  /**
   * Start recording the events of the routing
   */
  loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe({
        next: ({urlAfterRedirects}: NavigationEnd) => {
          this.history = [...this.history, urlAfterRedirects];
        },
        error: (err: unknown) => console.error('[RoutingStateService] Router events error:', err)
      });
  }

  /**
   * Get the history of the navigated url's
   * @returns {Array} of url's
   */
  getHistory(): string[] {
    return this.history;
  }

  /**
   * Get the previous navigated url. If there is no previous url return 'index'
   * @returns {any|string}
   */
  getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/index';
  }

}
